import type { IconSvgObject } from './types';

const CopyXIcon: IconSvgObject = [
  ["path", { d: "M13 2C10.1716 2 8.75736 2 7.87868 2.87868C7 3.75736 7 5.17157 7 8V12C7 14.8284 7 16.2426 7.87868 17.1213C8.75736 18 10.1716 18 13 18H15C17.8284 18 19.2426 18 20.1213 17.1213C21 16.2426 21 14.8284 21 12V8C21 5.17157 21 3.75736 20.1213 2.87868C19.2426 2 17.8284 2 15 2H13Z", stroke: "currentColor", fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 7.5L16.5 12.5M16.5 7.5L11.5 12.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 22H9C6.17157 22 4.75736 22 3.87868 21.1213C3 20.2426 3 18.8284 3 16V6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default CopyXIcon;
